import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
	100% {
		transform: rotate(360deg)
	}
`;

const loadingAnim = keyframes`
	0% {
		clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0)
	}
	25% {
		clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0)
	}
	50% {
		clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%)
	}
	75% {
		clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%)
	}
	100% {
		clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0)
	}
`;

export const Loader = styled.div`
    --size: 40px;
    --width: 3px;
    --color: black;

    width: var(--size);
    height: var(--size);
    border-radius: 50%;
    position: relative;
    left: calc(50% - (var(--size) / 2));
    top: calc(50% - (var(--size) / 2));
    align-self: normal;
    animation: ${rotate} 1s linear infinite;

    &:before {
        content: '';
        box-sizing: border-box;
        position: absolute;
        inset: 0;
        border-radius: 50%;
        border: var(--width) solid var(--color);
        animation: ${loadingAnim} 2s linear infinite;
    }
`;
